export enum ScheduleOwnerType {
    Doctor = 0,
    Cabinet = 1
}